const listPointsBody = document.querySelector('#filmAFConsider').querySelector('div[name=body]');

import auth from '../tools/storage.js';
import tools from '../tools/tools.js';
import buildBlocksJS from '../tools/buildBlocks.js';
import xhr from '../tools/xhr.js';
import toolsMarkup from '../markup/tools.js';

import cropWrap from '../tools/cropWrapper.js';

const cardLocalInput = document.querySelector('#filmLocalInput_Card');

const fName = cardLocalInput.querySelector('input[name=filmName]');
const fCreatorTXT = cardLocalInput.querySelector('input[name=creatorsTXT]');
const fCrewTXT = cardLocalInput.querySelector('textarea[name=crewsTXT]');
const fYear =  cardLocalInput.querySelector('select[name=year]'); 
const fAge =  cardLocalInput.querySelector('select[name=age]'); 
const fLong = cardLocalInput.querySelector('input[name=longTime]');
const fTechs = cardLocalInput.querySelector('input[name=techs]');
const fStudios = cardLocalInput.querySelector('input[name=studios]');
const fCountries = cardLocalInput.querySelector('input[name=countries]');
const fTypePremiere =  cardLocalInput.querySelector('select[name=typePremiere]');
const fNominations =  cardLocalInput.querySelector('select[name=nominations]');
const fDesc = cardLocalInput.querySelector('textarea[name=desc]');

const cardPhotoSpinner = cardLocalInput.querySelector('#uploadSpinner');
const cardPhotoSpinnerCreators = cardLocalInput.querySelector('#uploadSpinner-creators');

const cardPhotoTip = cardLocalInput.querySelector('b[name=photoTip]');
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(cardPhotoSpinner, loaderSpinnerMessage);

const cropWrapNode1 = cardLocalInput.querySelector('#image-uploader-wrapper-films');
const cropWrapNode2 = cardLocalInput.querySelector('#image-uploader-wrapper-creators');

const btSave = cardLocalInput.querySelector('button[name=save]');


const divSchedule = cardLocalInput.querySelector('div[name=schedule]');

let filmImageToUpload1 = null;
let filmImageToDelete1 = false;
let filmImageToUpload2 = null;
let filmImageToDelete2 = false;


let dctFilm;
let allNominaitons;


cropWrap.init(cropWrapNode1, false, {
  dataName: 'none',
  // aspectRatio: 1,
  onSave: (blob) => {
    filmImageToUpload1 = blob;
    sentPhoto();
  },
  onDelete: () => {
    filmImageToDelete1 = true;
  }
});



cropWrap.init(cropWrapNode2, false, {
  dataName: 'none',
  // aspectRatio: 1,
  onSave: (blob) => {
    filmImageToUpload2 = blob;
    sentPhotoCreators();
  },
  onDelete: () => {
    filmImageToDelete2 = true;
  }
});

const sentPhoto = () => {
  cardPhotoSpinner.innerHTML = loaderSpinnerMarkup;;
  cardPhotoTip.innerHTML = 'Загрузка фотографии...';
  cardPhotoSpinner.style.opacity = 1;
  xhr.request = {
    metod: 'POST',
    // url: `zeroplus23/img/films/111.jpg`,
    url: `localInputFilms/${cardLocalInput.getAttribute('filmID')}/photo/`,
    // url: `imgSaver`,
    data: filmImageToUpload1,
    callbackSuccess: (answer) => onSaveComplite(answer)
  };
};


const sentPhotoCreators = () => {
  cardPhotoSpinnerCreators.innerHTML = loaderSpinnerMarkup;;
  cardPhotoSpinnerCreators.style.opacity = 1;
  xhr.request = {
    metod: 'POST',
    // url: `zeroplus23/img/films/111.jpg`,
    url: `localInputFilms/${cardLocalInput.getAttribute('filmID')}/photoCreator/`,
    // url: `imgSaver`,
    data: filmImageToUpload2,
    callbackSuccess: (answer) => onSaveComplite(answer)
  };
};


const onSaveComplite = (answer) => {

  cropWrap.setImg(cropWrapNode1, './img/icons8-drag-and-drop-100.png');
  cropWrap.setImg(cropWrapNode2, './img/icons8-drag-and-drop-100.png');
  cardPhotoSpinner.style.opacity = 0;
  cardPhotoSpinnerCreators.style.opacity = 0;

  if (answer && answer.data) {
    onSuccessLoadlocalFilmCard(answer);
    cardPhotoTip.innerHTML = 'Фотография загружена';
  }

  cardPhotoSpinner.style.opacity = 0;
};

cardLocalInput.querySelector('div[name=img-on-server]').addEventListener('click', (evt) => {
  console.log(evt.target);
  if(evt.target.attributes.action){
    if(evt.target.getAttribute('action') == 'removeFrame')
      if(confirm('Удалить данное изображение?')){
          xhr.request = {
            metod: 'DELETE',
            // url: `zeroplus23/img/films/111.jpg`,
            url: `localInputFilms/${cardLocalInput.getAttribute('filmID')}/photo/${evt.target.getAttribute('nameFrame')}`,
            // url: `imgSaver`,
            data: '',
            callbackSuccess: (answer) => onSaveComplite(answer)
          };
      }
  }

})

cardLocalInput.querySelector('div[name=img-on-server-creators]').addEventListener('click', (evt) => {
  console.log(evt.target);
  if(evt.target.attributes.action){
    if(evt.target.getAttribute('action') == 'removeImgs')
      if(confirm('Удалить данное изображение?')){
          xhr.request = {
            metod: 'DELETE',
            // url: `zeroplus23/img/films/111.jpg`,
            url: `localInputFilms/${cardLocalInput.getAttribute('filmID')}/photoCreator/${evt.target.getAttribute('nameimgs')}`,
            // url: `imgSaver`,
            data: '',
            callbackSuccess: (answer) => onSaveComplite(answer)
          };
      }
  }

})

function loadCard (localFilmID) {

cropWrap.setImg(cropWrapNode1, './img/icons8-drag-and-drop-100.png');
cropWrap.setImg(cropWrapNode2, './img/icons8-drag-and-drop-100.png');
  
  cardPhotoTip.innerHTML =  'Чтобы загрузить фото, наведите курсор на выделенную пунктиром область.';
  xhr.request = {
    metod: 'GET',
    url: `localInputFilms/${localFilmID}/`,
    data: '',
    callbackSuccess: onSuccessLoadlocalFilmCard
  };
   
}

const onSuccessLoadlocalFilmCard = (servAnswer) => {

  if (servAnswer.status === 200) {
    initLimit();
    dctFilm = servAnswer.data;

    fName.value = dctFilm.name;
    fYear.value = dctFilm.year;
    fAge.value = dctFilm.age;
    fDesc.value = dctFilm.description;
    fLong.value = tools.secToFormattedLabel(dctFilm.long);
    fTechs.value = tools.jsonStringToString(dctFilm.techs);
    fStudios.value = tools.jsonStringToString(dctFilm.studios);
    fCountries.value = tools.jsonStringToString(dctFilm.countries);
    fTypePremiere.value = dctFilm.premiere;
    fCreatorTXT.value = tools.jsonStringToString(dctFilm.creatorsTXT);
    fCrewTXT.value = dctFilm.crewTXT;
    fNominations.value = dctFilm.nomination;

    // displayLocalFilmFrames(dctFilm.frames);

    cardPhotoSpinner.style.opacity = 0;
    let filmsOnServDiv = '';
    if (dctFilm.frames && dctFilm.frames.length > 4) {
      let filmsOnServ = JSON.parse(dctFilm.frames);
      filmsOnServ.forEach((item, index) => {
        filmsOnServDiv += `<div class="localImg" action="removeFrame" nameFrame="${item}">
                            <img src="https://festcontent.ru/fests/${auth.currentFestival}/img/films/${item}.jpg" action="removeFrame" nameFrame="${item}">
                          </div>`;
      });
     }
    
    cardLocalInput.querySelector('div[name=img-on-server]').innerHTML = filmsOnServDiv;

    let filmsImgCreatorsOnServDiv = '';
    if (dctFilm.creatorsImgs && dctFilm.creatorsImgs.length > 4) {
      let filmCreatorImgsOnServ = JSON.parse(dctFilm.creatorsImgs);
      filmCreatorImgsOnServ.forEach((item, index) => {
        filmsImgCreatorsOnServDiv += `<div class="localImg" action="removeImgs" nameImgs="${item}">
                            <img src="https://festcontent.ru/fests/${auth.currentFestival}/img/creators/${item}.jpg" action="removeImgs" nameImgs="${item}">
                          </div>`;
      });
     }
    
    cardLocalInput.querySelector('div[name=img-on-server-creators]').innerHTML = filmsImgCreatorsOnServDiv;
    

    if(dctFilm.schedule)
      divSchedule.innerHTML = '<h5 class"w-100 " style="padding:10px">Программы с данным фильмом в расписании:</h5>' + buildBlocksJS.blockScheduleWithNameProgram(dctFilm.schedule, 3);
    else
      divSchedule.innerHTML = '';

   if(dctFilm.programs){
      let emptyPrograms = [];
      dctFilm.programs.forEach((item, index) => {
        let bilo = false;
        if(dctFilm.schedule)
          dctFilm.schedule.forEach((sitem, index) => {
            if(sitem.programIDfk == item.programIDfk)
              bilo = true
          });

        if(!bilo)
          emptyPrograms.push(item);
      });
      divSchedule.innerHTML +=  '<h5 class"w-100"  style="padding:10px">Программы с данным фильмом  не добавленные в расписание:</h5>'  + buildBlocksJS.blockArrInProgram(emptyPrograms, 3);
    
   }

    console.log(dctFilm);


    cardLocalInput.setAttribute('filmID', dctFilm.id);
    $(cardLocalInput).modal('show');
  }
  
};

function initLimit(){
  tools.inputAddLimit(fName, 300);
  tools.inputAddLimit(fCreatorTXT, 250);
}


btSave.addEventListener('click', function () {
  let reqBody = '';
  reqBody += tools.checkDifferent('name',dctFilm.name, fName.value);
  reqBody += tools.checkDifferent('year',dctFilm.year, fYear.value);
  reqBody += tools.checkDifferent('description',dctFilm.description, fDesc.value);
  reqBody += tools.checkDifferent('crewTXT',dctFilm.crewTXT, fCrewTXT.value);
  // reqBody += tools.checkDifferent('creatorsTXT',dctFilm.creatorsTXT, fCreatorTXT.value);
  reqBody += tools.checkDifferent('techs',dctFilm.techs, tools.strArrayToJsonString(fTechs.value));
  reqBody += tools.checkDifferent('countries',dctFilm.countries, tools.strArrayToJsonString(fCountries.value));
  reqBody += tools.checkDifferent('studios',dctFilm.studios, tools.strArrayToJsonString(fStudios.value));
  reqBody += tools.checkDifferent('creatorsTXT',dctFilm.creatorsTXT, tools.strArrayToJsonString(fCreatorTXT.value));

  let longArray = fLong.value.split(':').reverse();
  let longSec = 0;
  for(let l = 0;l < longArray.length; ++l)
    if(l == 0)
        longSec += parseInt(longArray[0], 10);
      else
        longSec += parseInt(longArray[l], 10) * (60 * l);
  
  reqBody += tools.checkDifferent('long',dctFilm.long, longSec);
  reqBody += tools.checkDifferent('age',dctFilm.age, fAge.value);
  reqBody += tools.checkDifferent('premiere',dctFilm.premiere, fTypePremiere.value);
  reqBody += tools.checkDifferent('nomination',dctFilm.nomination, fNominations.value);

  // console.log(reqBody);
  if (reqBody.length > 2) {
    reqBody = reqBody.slice(0, -1);
    btSave.classList.add('loading');
    xhr.request = {
      metod: 'PUT',
      url: `localInputFilms/${cardLocalInput.getAttribute('filmID')}/`,
      data: reqBody,
      callbackSuccess: onSuccessSavelocalFilmCard
    };
  } else 
    $(cardLocalInput).modal('hide');
  


});




const onSuccessSavelocalFilmCard = (servAnswer) => {
  btSave.classList.remove('loading');
  if (servAnswer.status === 200) {

    $(cardLocalInput).modal('hide');
  }
};

export default {


  openCard(localFilmID){
    loadCard(localFilmID); 
  },

  cleanContainer() {
    // listPointsBody.innerHTML = '';
  },

  getElement(item, index) {

    // let premiereStatus = '';
    
    // let fcID = ` fCID=${item.considerID} numReq=${item.numRequest} `;

    // if(parseInt(item.premiere, 10) === 1)
    //   premiereStatus = `<div class = "premiere-icon premiere-icon-russia"></div>`;
    // else   if(parseInt(item.premiere, 10) === 2)
    //   premiereStatus = `<div class = "premiere-icon  premiere-icon-world"></div>`;
    

    // return `<div class="reference-header  m-0 p-1 " ${fcID}> 
    //         <div  class="reference-column m-0 p-0"> 
    //           <label ${fcID}  class=" p-0 m-0 iconGroupOfConsider">${item.numRequest  }</label>
    //         </div>  
    //         <label ${fcID}  class="reference-column m-0 p-0 pl-1">${item.name} ${premiereStatus}</label>
    //       </div>`;
  },

  drawDataInContainer(listWithData) {
    // this.cleanContainer();

    // let HTMLBODY = '';

    // // console.log(typeSort.value);

    // if(listWithData) {

    //   listPointsBody.classList.remove('row');
    //   listPointsBody.classList.remove('column');
    //   listPointsBody.classList.add('column');
    //   HTMLBODY = '';

    //   listWithData.forEach((item, index) => {

    //       HTMLBODY += `
    //       <div class="reference-header firstRow">
    //           <div class="reference-column">№</div>
    //           <div class="reference-column">Название работы</div>
    //       </div>
    //       `;

    //     HTMLBODY += this.getElement(item, index);
    //   });
    //   listPointsBody.innerHTML = HTMLBODY;
    // } else
    //   listPointsBody.innerHTML = 'Данных пока нет';
  },


  drawMarkupInContainer(markup) {
    // listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
